@if (state.context(); as context) {
	<div class="config-shell">
		<aside class="sidebar">
			<div class="brand">
				<img src="/assets/logo_white.png" alt="" style="max-width: 4.5rem" />
				<div><strong>Pressteaze</strong><small>Back Office</small></div>
			</div>
			<mat-form-field appearance="outline" class="store-switcher">
				<mat-label>Κατάστημα</mat-label>
				<select
					matNativeControl
					[ngModel]="context.selected_store_id"
					(ngModelChange)="selectStore($event)"
				>
					@for (store of context.stores; track store.id) {
						<option [value]="store.id">{{ store.name }}</option>
					}
				</select>
			</mat-form-field>
			<nav aria-label="Ενότητες ρυθμίσεων">
				<button
					[class.active]="section() === 'store'"
					(click)="setSection('store')"
				>
					<span>01</span> Κατάστημα
				</button>
				<button
					[class.active]="section() === 'spaces'"
					(click)="setSection('spaces')"
				>
					<span>02</span> Χώροι & τραπέζια
				</button>
				<button
					[class.active]="section() === 'hours'"
					(click)="setSection('hours')"
				>
					<span>03</span> Ωράριο
				</button>
				@if (context.capabilities.manage_users) {
					<button
						[class.active]="section() === 'users'"
						(click)="setSection('users')"
					>
						<span>04</span> Ομάδα
					</button>
				}
				@if (context.capabilities.manage_domains) {
					<button
						[class.active]="section() === 'domains'"
						(click)="setSection('domains')"
					>
						<span>05</span> Domains
					</button>
				}
			</nav>
			<div class="profile">
				<div class="avatar">{{ context.user.full_name.charAt(0) }}</div>
				<div>
					<strong>{{ context.user.full_name }}</strong>
					<small>{{ context.user.role }}</small>
				</div>
				<button (click)="logout()" title="Αποσύνδεση">↗</button>
			</div>
		</aside>

		<main class="workspace">
			<header>
				<div>
					<div style="display: flex">
						<h2 class="status">
							{{ state.selectedStore()?.name }}
							<i [attr.enabled]="state.selectedStore()?.is_active"></i>
						</h2>
						<!-- <span class="status">
							
							{{ state.selectedStore()?.is_active ? 'Ενεργό' : 'Ανενεργό' }}
						</span> -->
					</div>
					<h1>
						{{
							section() === 'store'
								? 'Ρυθμίσεις καταστήματος'
								: section() === 'spaces'
									? 'Χώροι & τραπέζια'
									: section() === 'hours'
										? 'Ωράριο & εξαιρέσεις'
										: section() === 'users'
											? 'Ομάδα & πρόσβαση'
											: 'Domains & ιδιοκτησία'
						}}
					</h1>
				</div>
			</header>
			@if (editor()) {
				<button
					type="button"
					class="modal-backdrop"
					aria-label="Κλείσιμο παραθύρου"
					(click)="closeEditor()"
				></button>
			}
			@if (!context.stores.length && !context.capabilities.create_store) {
				<div class="empty">
					Δεν σας έχει ανατεθεί κατάστημα. Επικοινωνήστε με διαχειριστή.
				</div>
			}

			@if (section() === 'store') {
				<section class="content-grid">
					<div class="panel wide">
						<div class="panel-head">
							<div>
								<span>ΚΑΤΑΣΤΗΜΑΤΑ</span>
								<h2>Βασικά στοιχεία</h2>
							</div>
							@if (context.capabilities.create_store) {
								<button
									class="add-button"
									[attr.record-action]="RecordAction.Add"
									title="Νέο κατάστημα"
									(click)="newStore()"
								>
									+
								</button>
							}
						</div>
						<div class="rows">
							@for (store of context.stores; track store.id) {
								<div class="row">
									<span
										><b>{{ store.name }}</b
										><small
											>{{ store.slug }} · {{ store.timezone }}</small
										></span
									>
									<em [class.off]="!store.is_active">{{
										store.is_active ? 'Ενεργό' : 'Ανενεργό'
									}}</em>

									<button
										class="icon-button"
										[attr.record-action]="RecordAction.Edit"
										aria-label="Επεξεργασία καταστήματος"
										title="Επεξεργασία καταστήματος"
										(click)="editStore(store)"
									></button>
								</div>
							}
						</div>
						@if (editor() === 'store') {
							<div
								class="modal-card wide-modal"
								role="dialog"
								aria-modal="true"
							>
								<div class="modal-head">
									<div>
										<span>ΚΑΤΑΣΤΗΜΑ</span>
										<h2>{{ storeDraft.id ? 'Επεξεργασία' : 'Δημιουργία' }}</h2>
									</div>
									<button
										type="button"
										class="modal-close"
										(click)="closeEditor()"
									>
										×
									</button>
								</div>
								<form (ngSubmit)="saveStore()" class="form-grid modal-form">
									<mat-form-field appearance="outline">
										<mat-label>Όνομα</mat-label>
										<input
											matInput
											required
											name="storeName"
											[(ngModel)]="storeDraft.name"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Slug</mat-label>
										<input
											matInput
											required
											name="storeSlug"
											[(ngModel)]="storeDraft.slug"
											placeholder="athens-center"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Ζώνη ώρας</mat-label>
										<input
											matInput
											required
											name="timezone"
											[(ngModel)]="storeDraft.timezone"
										/>
									</mat-form-field>
									<label class="check"
										><input
											type="checkbox"
											name="storeActive"
											[(ngModel)]="storeDraft.is_active"
										/>
										Ενεργό κατάστημα</label
									>
									<div class="divider"></div>
									<h3>Προεπιλογές κρατήσεων</h3>
									<mat-form-field appearance="outline">
										<mat-label>Διάρκεια θέσης (λεπτά)</mat-label>
										<input
											matInput
											type="number"
											min="1"
											required
											name="duration"
											[(ngModel)]="storeDraft.seating_duration_min"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Διάστημα slots (λεπτά)</mat-label>
										<input
											matInput
											type="number"
											min="1"
											required
											name="slot"
											[(ngModel)]="storeDraft.booking_slot_interval_min"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Ελάχιστη προειδοποίηση</mat-label>
										<input
											matInput
											type="number"
											min="0"
											required
											name="notice"
											[(ngModel)]="storeDraft.min_booking_notice_min"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Ημέρες μπροστά</mat-label>
										<input
											matInput
											type="number"
											min="1"
											required
											name="ahead"
											[(ngModel)]="storeDraft.max_booking_days_ahead"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Επιβεβαίωση πάνω από άτομα</mat-label>
										<input
											matInput
											type="number"
											min="1"
											name="confirmation"
											[(ngModel)]="storeDraft.confirmation_required_above"
											placeholder="Χωρίς όριο"
										/>
									</mat-form-field>
									<div class="actions">
										<button class="primary" [disabled]="state.loading()">
											Αποθήκευση
										</button>
									</div>
								</form>
							</div>
						}
					</div>
					<!-- <aside class="note">
						<b>Σημείωση</b>
						<p>
							Η απενεργοποίηση διατηρεί το ιστορικό κρατήσεων και είναι
							προτιμότερη από τη διαγραφή.
						</p>
					</aside> -->
				</section>
			}

			@if (section() === 'spaces') {
				<section class="split">
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ΧΩΡΟΙ</span>
								<!-- <h2>Σειρά αυτόματης ανάθεσης</h2> -->
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέος χώρος"
								(click)="newArea()"
							>
								+
							</button>
						</div>
						<p class="hint">
							Η μικρότερη προτεραιότητα γεμίζει πρώτη. Χρησιμοποιήστε 100, 200,
							300 ώστε να χωρούν ενδιάμεσες τιμές.
						</p>
						<div class="rows">
							@for (area of context.areas; track area.id) {
								<div class="row">
									<span
										><b>{{ area.name }}</b
										><small
											>Προτεραιότητα {{ area.auto_assign_priority }} · Σειρά
											{{ area.sort_order }}</small
										></span
									><em [class.off]="!area.is_active">{{
										area.is_active ? 'Ενεργός' : 'Ανενεργός'
									}}</em
									><button
										class="icon-button"
										aria-label="Επεξεργασία χώρου"
										[attr.record-action]="RecordAction.Edit"
										title="Επεξεργασία χώρου"
										(click)="editArea(area)"
									>
										✎
									</button>
								</div>
							}
						</div>
					</div>
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ΤΡΑΠΕΖΙΑ</span>
								<!-- <h2>Δυναμικότητα</h2> -->
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέο τραπέζι"
								(click)="newTable()"
							>
								+
							</button>
						</div>
						<div class="rows">
							@for (table of context.tables; track table.id) {
								<div class="row">
									<span
										><b>{{ table.name }}</b
										><small
											>{{ table.seats }} θέσεις ·
											{{ areaName(table.area_id) }}</small
										></span
									><em [class.off]="!table.is_active">{{
										table.is_active ? 'Ενεργό' : 'Ανενεργό'
									}}</em
									><button
										class="icon-button"
										aria-label="Επεξεργασία τραπεζιού"
										[attr.record-action]="RecordAction.Edit"
										title="Επεξεργασία τραπεζιού"
										(click)="editTable(table)"
									>
										✎
									</button>
								</div>
							}
						</div>
					</div>
				</section>
				@if (editor() === 'area') {
					<div class="modal-card" role="dialog" aria-modal="true">
						<div class="modal-head">
							<div>
								<span>ΧΩΡΟΣ</span>
								<h2>{{ areaDraft.id ? 'Επεξεργασία' : 'Δημιουργία' }}</h2>
							</div>
							<button class="modal-close" type="button" (click)="closeEditor()">
								×
							</button>
						</div>
						<form (ngSubmit)="saveArea()" class="compact-form modal-form">
							<mat-form-field appearance="outline"
								><mat-label>Όνομα</mat-label
								><input
									matInput
									required
									name="areaName"
									[(ngModel)]="areaDraft.name"
							/></mat-form-field>
							<div class="pair">
								<mat-form-field appearance="outline"
									><mat-label>Προτεραιότητα</mat-label
									><input
										matInput
										type="number"
										name="priority"
										[(ngModel)]="
											areaDraft.auto_assign_priority
										" /></mat-form-field
								><mat-form-field appearance="outline"
									><mat-label>Σειρά</mat-label
									><input
										matInput
										type="number"
										name="sort"
										[(ngModel)]="areaDraft.sort_order"
								/></mat-form-field>
							</div>
							<label class="check"
								><input
									type="checkbox"
									name="selectable"
									[(ngModel)]="areaDraft.is_customer_selectable"
								/>
								Επιλογή από πελάτη</label
							><label class="check"
								><input
									type="checkbox"
									name="areaActive"
									[(ngModel)]="areaDraft.is_active"
								/>
								Ενεργός</label
							>
							<div class="actions">
								<button type="button" class="quiet" (click)="closeEditor()">
									Ακύρωση</button
								><button class="primary">Αποθήκευση</button>
							</div>
						</form>
					</div>
				}
				@if (editor() === 'table') {
					<div class="modal-card" role="dialog" aria-modal="true">
						<div class="modal-head">
							<div>
								<span>ΤΡΑΠΕΖΙ</span>
								<h2>{{ tableDraft.id ? 'Επεξεργασία' : 'Δημιουργία' }}</h2>
							</div>
							<button class="modal-close" type="button" (click)="closeEditor()">
								×
							</button>
						</div>
						<form (ngSubmit)="saveTable()" class="compact-form modal-form">
							<mat-form-field appearance="outline"
								><mat-label>Όνομα</mat-label
								><input
									matInput
									required
									name="tableName"
									[(ngModel)]="tableDraft.name"
							/></mat-form-field>
							<div class="pair">
								<mat-form-field appearance="outline"
									><mat-label>Χώρος</mat-label
									><select
										matNativeControl
										required
										name="tableArea"
										[(ngModel)]="tableDraft.area_id"
									>
										<option value="">Επιλέξτε</option>
										@for (area of context.areas; track area.id) {
											<option [value]="area.id">{{ area.name }}</option>
										}
									</select></mat-form-field
								><mat-form-field appearance="outline"
									><mat-label>Θέσεις</mat-label
									><input
										matInput
										type="number"
										min="1"
										required
										name="seats"
										[(ngModel)]="tableDraft.seats"
								/></mat-form-field>
							</div>
							<label class="check"
								><input
									type="checkbox"
									name="tableActive"
									[(ngModel)]="tableDraft.is_active"
								/>
								Ενεργό</label
							>
							<div class="actions">
								<button type="button" class="quiet" (click)="closeEditor()">
									Ακύρωση</button
								><button class="primary">Αποθήκευση</button>
							</div>
						</form>
					</div>
				}
			}

			@if (section() === 'hours') {
				<section class="stack">
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ΕΒΔΟΜΑΔΙΑΙΟ ΩΡΑΡΙΟ</span>
								<!-- <h2>Πολλαπλά διαστήματα ανά ημέρα</h2> -->
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέο διάστημα"
								(click)="addHour()"
							>
								+
							</button>
						</div>
						<div class="rows">
							@for (window of hourDrafts; track $index) {
								<div class="row">
									<span
										><b>{{ weekdays[window.weekday ?? 0] }}</b
										><small
											>{{ window.open_time }} – {{ window.close_time
											}}{{
												isOvernight(window) ? ' · επόμενη ημέρα' : ''
											}}</small
										></span
									><button
										class="icon-button"
										aria-label="Επεξεργασία διαστήματος"
										[attr.record-action]="RecordAction.Edit"
										title="Επεξεργασία διαστήματος"
										(click)="editHour($index)"
									>
										✎</button
									><button
										class="danger icon-button"
										[attr.record-action]="RecordAction.Delete"
										title="Αφαίρεση"
										(click)="deleteHour($index)"
									>
										×
									</button>
								</div>
							}
						</div>
					</div>
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ONLINE ΚΡΑΤΗΣΕΙΣ</span>
								<!-- <h2>Πρώτη και τελευταία ώρα έναρξης</h2> -->
								<p class="hint">
									Οι ώρες περιορίζουν μόνο τις online κρατήσεις. Η τελευταία ώρα
									είναι έγκυρη ώρα έναρξης, εφόσον η κράτηση ολοκληρώνεται πριν
									κλείσει το κατάστημα.
								</p>
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέο online διάστημα"
								(click)="addOnlineHour()"
							>
								+
							</button>
						</div>
						<div class="rows">
							@for (window of onlineHourDrafts; track $index) {
								<div class="row">
									<span
										><b>{{ weekdays[window.weekday ?? 0] }}</b
										><small
											>{{ window.first_start_time }} –
											{{ window.last_start_time
											}}{{
												isOnlineOvernight(window) ? ' · επόμενη ημέρα' : ''
											}}</small
										></span
									><button
										class="icon-button"
										aria-label="Επεξεργασία online διαστήματος"
										[attr.record-action]="RecordAction.Edit"
										title="Επεξεργασία online διαστήματος"
										(click)="editOnlineHour($index)"
									>
										✎</button
									><button
										class="danger icon-button"
										[attr.record-action]="RecordAction.Delete"
										title="Αφαίρεση"
										(click)="deleteOnlineHour($index)"
									>
										×
									</button>
								</div>
							}
						</div>
					</div>
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ΗΜΕΡΟΜΗΝΙΕΣ</span>
								<h2>Αργίες & εξαιρέσεις</h2>
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέα εξαίρεση"
								(click)="newException()"
							>
								+
							</button>
						</div>
						<div class="exception-layout">
							<div class="rows">
								@for (exception of context.exceptions; track exception.id) {
									<div class="row">
										<button (click)="editException(exception)">
											<b>{{ exception.service_date }}</b
											><small
												>{{
													exception.is_closed
														? 'Κλειστά όλη ημέρα'
														: 'Ειδικό ωράριο'
												}}{{
													exception.reason ? ' · ' + exception.reason : ''
												}}</small
											></button
										><button
											class="icon-button"
											aria-label="Επεξεργασία εξαίρεσης"
											[attr.record-action]="RecordAction.Edit"
											title="Επεξεργασία εξαίρεσης"
											(click)="editException(exception)"
										>
											✎</button
										><button
											class="danger icon-button"
											[attr.record-action]="RecordAction.Delete"
											aria-label="Διαγραφή εξαίρεσης"
											title="Διαγραφή εξαίρεσης"
											(click)="deleteException(exception.id)"
										>
											Αφαίρεση
										</button>
									</div>
								}
							</div>
							@if (editor() === 'exception') {
								<div class="modal-card" role="dialog" aria-modal="true">
									<div class="modal-head">
										<div>
											<span>ΕΞΑΙΡΕΣΗ</span>
											<h2>
												{{ exceptionDraft.id ? 'Επεξεργασία' : 'Δημιουργία' }}
											</h2>
										</div>
										<button
											class="modal-close"
											type="button"
											(click)="closeEditor()"
										>
											×
										</button>
									</div>
									<form
										(ngSubmit)="saveException()"
										class="compact-form modal-form"
									>
										<mat-form-field appearance="outline">
											<mat-label>Ημερομηνία</mat-label>
											<input
												matInput
												required
												type="date"
												name="exceptionDate"
												[(ngModel)]="exceptionDraft.service_date"
											/>
										</mat-form-field>
										<label class="check"
											><input
												type="checkbox"
												name="closed"
												[(ngModel)]="exceptionDraft.is_closed"
											/>
											Κλειστά όλη ημέρα</label
										>
										<mat-form-field appearance="outline">
											<mat-label>Αιτία</mat-label>
											<input
												matInput
												name="reason"
												[(ngModel)]="exceptionDraft.reason"
												placeholder="π.χ. Χριστούγεννα"
											/>
										</mat-form-field>
										@if (!exceptionDraft.is_closed) {
											<div class="mini-windows">
												@for (window of exceptionDraft.windows; track $index) {
													<div>
														<mat-form-field appearance="outline">
															<mat-label>Από</mat-label>
															<input
																matInput
																type="time"
																[(ngModel)]="window.open_time"
																[name]="'exOpen' + $index"
															/>
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Έως</mat-label>
															<input
																matInput
																type="time"
																[(ngModel)]="window.close_time"
																[name]="'exClose' + $index"
															/>
														</mat-form-field>
														<button
															type="button"
															(click)="removeExceptionWindow($index)"
														>
															×
														</button>
													</div>
												}
												<button
													type="button"
													class="quiet"
													(click)="addExceptionWindow()"
												>
													+ Ώρες
												</button>
											</div>
										}
										<div class="actions">
											<button class="primary">Αποθήκευση εξαίρεσης</button>
										</div>
									</form>
								</div>
							}
						</div>
					</div>
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ONLINE ΗΜΕΡΟΜΗΝΙΕΣ</span>
								<h2>Εξαιρέσεις online κρατήσεων</h2>
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέα online εξαίρεση"
								(click)="newOnlineException()"
							>
								+
							</button>
						</div>
						<div class="exception-layout">
							<div class="rows">
								@for (
									exception of context.online_booking_exceptions;
									track exception.id
								) {
									<div class="row">
										<button (click)="editOnlineException(exception)">
											<b>{{ exception.service_date }}</b>
											<small
												>{{
													exception.is_disabled
														? 'Χωρίς online κρατήσεις'
														: 'Ειδικές ώρες έναρξης'
												}}{{
													exception.reason ? ' · ' + exception.reason : ''
												}}</small
											>
										</button>
										<button
											class="icon-button"
											aria-label="Επεξεργασία online εξαίρεσης"
											[attr.record-action]="RecordAction.Edit"
											title="Επεξεργασία online εξαίρεσης"
											(click)="editOnlineException(exception)"
										>
											✎
										</button>
										<button
											class="danger icon-button"
											[attr.record-action]="RecordAction.Delete"
											aria-label="Διαγραφή online εξαίρεσης"
											title="Διαγραφή online εξαίρεσης"
											(click)="deleteOnlineException(exception.id)"
										>
											Αφαίρεση
										</button>
									</div>
								}
							</div>
							@if (editor() === 'online-exception') {
								<div class="modal-card" role="dialog" aria-modal="true">
									<div class="modal-head">
										<div>
											<span>ONLINE ΕΞΑΙΡΕΣΗ</span>
											<h2>
												{{
													onlineExceptionDraft.id ? 'Επεξεργασία' : 'Δημιουργία'
												}}
											</h2>
										</div>
										<button
											class="modal-close"
											type="button"
											(click)="closeEditor()"
										>
											×
										</button>
									</div>
									<form
										(ngSubmit)="saveOnlineException()"
										class="compact-form modal-form"
									>
										<mat-form-field appearance="outline">
											<mat-label>Ημερομηνία</mat-label>
											<input
												matInput
												required
												type="date"
												name="onlineExceptionDate"
												[(ngModel)]="onlineExceptionDraft.service_date"
											/>
										</mat-form-field>
										<label class="check">
											<input
												type="checkbox"
												name="onlineDisabled"
												[(ngModel)]="onlineExceptionDraft.is_disabled"
											/>
											Χωρίς online κρατήσεις
										</label>
										<mat-form-field appearance="outline">
											<mat-label>Αιτία</mat-label>
											<input
												matInput
												name="onlineReason"
												[(ngModel)]="onlineExceptionDraft.reason"
												placeholder="π.χ. Ιδιωτική εκδήλωση"
											/>
										</mat-form-field>
										@if (!onlineExceptionDraft.is_disabled) {
											<div class="mini-windows">
												@for (
													window of onlineExceptionDraft.windows;
													track $index
												) {
													<div>
														<mat-form-field appearance="outline">
															<mat-label>Πρώτη έναρξη</mat-label>
															<input
																matInput
																type="time"
																[(ngModel)]="window.first_start_time"
																[name]="'onlineExFirst' + $index"
															/>
														</mat-form-field>
														<mat-form-field appearance="outline">
															<mat-label>Τελευταία έναρξη</mat-label>
															<input
																matInput
																type="time"
																[(ngModel)]="window.last_start_time"
																[name]="'onlineExLast' + $index"
															/>
														</mat-form-field>
														<button
															type="button"
															(click)="removeOnlineExceptionWindow($index)"
														>
															×
														</button>
													</div>
												}
												<button
													type="button"
													class="quiet"
													(click)="addOnlineExceptionWindow()"
												>
													+ Ώρες έναρξης
												</button>
											</div>
										}
										<div class="actions">
											<button class="primary">
												Αποθήκευση online εξαίρεσης
											</button>
										</div>
									</form>
								</div>
							}
						</div>
					</div>
					@if (editor() === 'hour') {
						<div class="modal-card" role="dialog" aria-modal="true">
							<div class="modal-head">
								<div>
									<span>ΩΡΑΡΙΟ</span>
									<h2>
										{{
											editingHourIndex === null
												? 'Νέο διάστημα'
												: 'Επεξεργασία διαστήματος'
										}}
									</h2>
								</div>
								<button
									class="modal-close"
									type="button"
									(click)="closeEditor()"
								>
									×
								</button>
							</div>
							<form (ngSubmit)="saveHour()" class="compact-form modal-form">
								<mat-form-field appearance="outline"
									><mat-label>Ημέρα</mat-label
									><select
										matNativeControl
										name="hourDay"
										[(ngModel)]="hourDraft.weekday"
									>
										@for (day of weekdays; track $index) {
											<option [ngValue]="$index">{{ day }}</option>
										}
									</select></mat-form-field
								>
								<div class="pair">
									<mat-form-field appearance="outline"
										><mat-label>Από</mat-label
										><input
											matInput
											required
											type="time"
											name="hourOpen"
											[(ngModel)]="hourDraft.open_time" /></mat-form-field
									><mat-form-field appearance="outline"
										><mat-label>Έως</mat-label
										><input
											matInput
											required
											type="time"
											name="hourClose"
											[(ngModel)]="hourDraft.close_time"
									/></mat-form-field>
								</div>
								<div class="actions">
									<button type="button" class="quiet" (click)="closeEditor()">
										Ακύρωση</button
									><button class="primary">Αποθήκευση</button>
								</div>
							</form>
						</div>
					}
					@if (editor() === 'online-hour') {
						<div class="modal-card" role="dialog" aria-modal="true">
							<div class="modal-head">
								<div>
									<span>ONLINE ΩΡΑΡΙΟ</span>
									<h2>
										{{
											editingOnlineHourIndex === null
												? 'Νέο διάστημα'
												: 'Επεξεργασία διαστήματος'
										}}
									</h2>
								</div>
								<button
									class="modal-close"
									type="button"
									(click)="closeEditor()"
								>
									×
								</button>
							</div>
							<form
								(ngSubmit)="saveOnlineHour()"
								class="compact-form modal-form"
							>
								<mat-form-field appearance="outline"
									><mat-label>Ημέρα</mat-label
									><select
										matNativeControl
										name="onlineHourDay"
										[(ngModel)]="onlineHourDraft.weekday"
									>
										@for (day of weekdays; track $index) {
											<option [ngValue]="$index">{{ day }}</option>
										}
									</select></mat-form-field
								>
								<div class="pair">
									<mat-form-field appearance="outline"
										><mat-label>Πρώτη έναρξη</mat-label
										><input
											matInput
											required
											type="time"
											name="onlineHourFirst"
											[(ngModel)]="
												onlineHourDraft.first_start_time
											" /></mat-form-field
									><mat-form-field appearance="outline"
										><mat-label>Τελευταία έναρξη</mat-label
										><input
											matInput
											required
											type="time"
											name="onlineHourLast"
											[(ngModel)]="onlineHourDraft.last_start_time"
									/></mat-form-field>
								</div>
								<div class="actions">
									<button type="button" class="quiet" (click)="closeEditor()">
										Ακύρωση</button
									><button class="primary">Αποθήκευση</button>
								</div>
							</form>
						</div>
					}
				</section>
			}

			@if (section() === 'users' && context.capabilities.manage_users) {
				<section class="split users">
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>ΧΡΗΣΤΕΣ</span>
								<h2>Πρόσβαση ομάδας</h2>
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέος χρήστης"
								(click)="newUser()"
							>
								+
							</button>
						</div>
						<div class="rows">
							@for (user of context.users; track user.id) {
								<div class="row user-row">
									<div class="user-summary">
										<span
											><b>{{ user.full_name }}</b
											><small
												>{{ user.username || 'PIN-only' }} ·
												{{ user.role }}</small
											></span
										><span class="user-status">
											<em [class.off]="!user.is_active">{{
												user.is_active ? 'Ενεργός' : 'Ανενεργός'
											}}</em>
										</span>
									</div>
									@if (user.role !== 'owner') {
										<div class="user-actions">
											@if (canEditUser(user)) {
												<button
													type="button"
													class="icon-button"
													aria-label="Επεξεργασία χρήστη"
													[attr.record-action]="RecordAction.Edit"
													title="Επεξεργασία χρήστη"
													(click)="editUser(user)"
												></button>
											}
											<button class="quiet" (click)="setPin(user.id)">
												PIN
											</button>
											@if (user.is_active) {
												<button
													class="danger"
													(click)="deactivateUser(user.id)"
												>
													Απενεργοποίηση
												</button>
											}
										</div>
									}
								</div>
							}
						</div>
					</div>
					@if (editor() === 'user') {
						<div class="modal-card" role="dialog" aria-modal="true">
							<div class="modal-head">
								<div>
									<span>{{
										userDraft.id ? 'ΕΠΕΞΕΡΓΑΣΙΑ' : 'ΝΕΟΣ ΧΡΗΣΤΗΣ'
									}}</span>
									<h2>Ταυτότητα & ρόλος</h2>
								</div>
								<button
									class="modal-close"
									type="button"
									(click)="closeEditor()"
								>
									×
								</button>
							</div>
							<form (ngSubmit)="saveUser()" class="compact-form modal-form">
								<mat-form-field appearance="outline">
									<mat-label>Ονοματεπώνυμο</mat-label>
									<input
										matInput
										required
										name="fullName"
										[(ngModel)]="userDraft.full_name"
									/>
								</mat-form-field>
								<mat-form-field appearance="outline">
									<mat-label>Ρόλος</mat-label>
									<select
										matNativeControl
										name="role"
										[disabled]="isEditingCurrentUser()"
										[(ngModel)]="userDraft.role"
									>
										@for (role of roles; track role) {
											<option [value]="role">{{ role }}</option>
										}
									</select>
								</mat-form-field>
								@if (!userDraft.id && userDraft.role !== 'operator') {
									<mat-form-field appearance="outline">
										<mat-label>Username</mat-label>
										<input
											matInput
											required
											name="username"
											[(ngModel)]="userDraft.username"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Πραγματικό email σύνδεσης</mat-label>
										<input
											matInput
											required
											type="email"
											name="email"
											[(ngModel)]="userDraft.email"
										/>
									</mat-form-field>
									<mat-form-field appearance="outline">
										<mat-label>Προσωρινός κωδικός</mat-label>
										<input
											matInput
											required
											minlength="8"
											type="password"
											name="password"
											[(ngModel)]="userDraft.password"
										/>
									</mat-form-field>
								}
								<mat-form-field appearance="outline">
									<mat-label>Email επικοινωνίας</mat-label>
									<input
										matInput
										type="email"
										name="contactEmail"
										[(ngModel)]="userDraft.contact_email"
									/>
								</mat-form-field>
								@if (!userDraft.id) {
									<mat-form-field appearance="outline">
										<mat-label>PIN (προαιρετικό)</mat-label>
										<input
											matInput
											inputmode="numeric"
											name="pin"
											[(ngModel)]="userDraft.pin"
										/>
									</mat-form-field>
								}
								<fieldset>
									<legend>Ανάθεση καταστημάτων</legend>
									@for (store of context.stores; track store.id) {
										<label class="check"
											><input
												type="checkbox"
												[checked]="userDraft.store_ids.includes(store.id)"
												(change)="
													toggleUserStore(store.id, $any($event.target).checked)
												"
											/>
											{{ store.name }}</label
										>
									}
								</fieldset>
								<mat-form-field appearance="outline">
									<mat-label>Προεπιλεγμένο κατάστημα</mat-label>
									<select
										matNativeControl
										name="defaultStore"
										[(ngModel)]="userDraft.default_store_id"
									>
										<option value="">Χωρίς προεπιλογή</option>
										@for (store of context.stores; track store.id) {
											@if (userDraft.store_ids.includes(store.id)) {
												<option [value]="store.id">{{ store.name }}</option>
											}
										}
									</select>
								</mat-form-field>
								<div class="actions">
									<button type="button" class="quiet" (click)="resetUser()">
										Καθαρισμός</button
									><button class="primary">Αποθήκευση χρήστη</button>
								</div>
							</form>
						</div>
					}
				</section>
			}

			@if (section() === 'domains' && context.capabilities.manage_domains) {
				<section class="stack">
					<div class="panel">
						<div class="panel-head">
							<div>
								<span>CUSTOM DOMAINS</span>
								<h2>DNS επαλήθευση</h2>
							</div>
							<button
								class="add-button"
								[attr.record-action]="RecordAction.Add"
								title="Νέο domain"
								(click)="newDomain()"
							>
								+
							</button>
						</div>
						@if (editor() === 'domain') {
							<div class="modal-card" role="dialog" aria-modal="true">
								<div class="modal-head">
									<div>
										<span>DOMAIN</span>
										<h2>{{ domainDraft.id ? 'Επεξεργασία' : 'Δημιουργία' }}</h2>
									</div>
									<button
										class="modal-close"
										type="button"
										(click)="closeEditor()"
									>
										×
									</button>
								</div>
								<form (ngSubmit)="saveDomain()" class="compact-form modal-form">
									<mat-form-field appearance="outline">
										<mat-label>Domain</mat-label>
										<input
											matInput
											required
											[readonly]="!!domainDraft.id"
											name="domain"
											[(ngModel)]="domainDraft.domain"
											placeholder="book.example.gr"
										/>
									</mat-form-field>
									<label class="check"
										><input
											type="checkbox"
											name="primary"
											[(ngModel)]="domainDraft.is_primary"
										/>
										Κύριο</label
									>
									<div class="actions">
										<button type="button" class="quiet" (click)="closeEditor()">
											Ακύρωση</button
										><button class="primary">
											{{ domainDraft.id ? 'Αποθήκευση' : 'Προσθήκη' }}
										</button>
									</div>
								</form>
							</div>
						}
						<div class="domain-list">
							@for (domain of context.domains; track domain.id) {
								<article>
									<div>
										<b>{{ domain.domain }}</b
										><span [class.verified]="domain.verified_at">{{
											domain.verified_at ? 'Επαληθευμένο' : 'Αναμονή DNS'
										}}</span
										><small>SSL: {{ domain.ssl_status }}</small>
										@if (domain.provisioning_error) {
											<small>{{ domain.provisioning_error }}</small>
										}
									</div>
									<div class="domain-actions">
										<button
											class="icon-button"
											aria-label="Επεξεργασία domain"
											[attr.record-action]="RecordAction.Edit"
											title="Επεξεργασία domain"
											(click)="editDomain(domain)"
										>
											✎
										</button>
										@if (domain.challenge; as challenge) {
											<dl>
												<dt>TXT όνομα</dt>
												<dd>
													<code>{{ challenge.record_name }}</code
													><button (click)="copy(challenge.record_name)">
														Αντιγραφή
													</button>
												</dd>
												<dt>TXT τιμή</dt>
												<dd>
													<code>{{ challenge.expected_value }}</code
													><button (click)="copy(challenge.expected_value)">
														Αντιγραφή
													</button>
												</dd>
											</dl>
											<button
												class="primary small"
												(click)="verifyDomain(domain.id)"
											>
												Έλεγχος DNS
											</button>
										} @else if (domain.verified_at) {
											<button class="quiet" (click)="refreshDomain(domain.id)">
												Ανανέωση SSL
											</button>
										}
									</div>
								</article>
							}
						</div>
					</div>
					@if (context.capabilities.transfer_ownership) {
						<div class="panel ownership">
							<div>
								<span>ΙΔΙΟΚΤΗΣΙΑ</span>
								<h2>Μεταβίβαση οργανισμού</h2>
								<p>
									Η ενέργεια είναι atomic: ο οργανισμός δεν μένει ποτέ χωρίς
									έναν ενεργό owner.
								</p>
							</div>
							<div>
								<mat-form-field appearance="outline">
									<mat-label>Νέος ιδιοκτήτης</mat-label>
									<select matNativeControl [(ngModel)]="ownershipTarget">
										<option value="">Επιλέξτε ενεργό χρήστη</option>
										@for (user of context.users; track user.id) {
											@if (
												user.is_active &&
												user.role !== 'owner' &&
												user.role !== 'operator'
											) {
												<option [value]="user.id">
													{{ user.full_name }} · {{ user.role }}
												</option>
											}
										}
									</select>
								</mat-form-field>
								<button class="danger solid" (click)="transferOwnership()">
									Μεταβίβαση
								</button>
							</div>
						</div>
					}
				</section>
			}
		</main>
	</div>
} @else {
	<div class="loading">
		<span></span>
		<p>Φόρτωση ρυθμίσεων…</p>
	</div>
}
